import { NullLogger } from "@aspnet/signalr";
import BaseModel from "../base/BaseModel.model";

export default class IndicatorModel extends BaseModel {

    public name: string | null = null;
    public indicatorTypeId:number | null = null;
    public isCompound: boolean = false;
    public indicatorFatherId:number | null;
    public indicadorNo:number | null;

  
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.name = null;
        this.indicatorTypeId= null;
        this.isCompound = false;
        this.indicatorFatherId =null;
        this.indicadorNo = null;
    }
}